<template>
  <div class="relative w-$portalContainerWidth mx-auto">
    <NavigationBarProps></NavigationBarProps>
    <div class="flex mt-20px">
      <div class="w-1/3 mr-10px">
        <column-header class="mb-10px" title="行政办公" :showMore="false" />
        <div class="w-full flex">
          <div
            class="w-full h-50px bg-hex-F0F9FF rounded-6px flex items-center justify-center cursor-pointer"
            @click="toHandle(0)"
          >
            <div class="w-20px h-20px ml-10px clock"></div>
            <div class="flex-1 flex justify-between px-10px items-center">
              <span class="text-14px text-hex-3B9BF0">我的待办</span>
              <span class="text-24px text-hex-3B9BF0 font-bold flex items-center"
                >{{ page.total }}<i class="el-icon-arrow-right text-20px font-bold"></i
              ></span>
            </div>
          </div>
        </div>
        <div class="w-full flex mt-10px">
          <div
            class="w-full h-50px bg-hex-EAFFEF rounded-6px flex items-center justify-center cursor-pointer"
            @click="toHandle(1)"
          >
            <div class="w-20px h-20px ml-10px complete"></div>
            <div class="flex-1 flex justify-between px-10px items-center">
              <span class="text-14px text-hex-25E154">我的已办</span>
              <span class="text-24px text-hex-25E154 font-bold flex items-center"
                >{{ doneListNum }}<i class="el-icon-arrow-right text-20px font-bold"></i
              ></span>
            </div>
          </div>
          <!-- <div
            class="w-1/3 h-50px ml-5px bg-hex-FFF8F0 rounded-6px flex items-center justify-center cursor-pointer"
          >
            <div class="w-20px h-20px ml-10px draft"></div>
            <div class="flex-1 flex justify-between px-10px justify-center items-center">
              <span class="text-14px text-hex-FFC01D">草稿箱</span>
            </div>
          </div> -->
        </div>
        <div class="w-full mt-20px mb-20px border-t-1 border-dashed border-hex-E2E2E2"></div>
        <div
          class="w-full h-[calc(100%-240px)] min-h-150px overflow-x-hidden overflow-y-hidden showTable"
        >
          <div class="h-full w-full">
            <div
              v-for="(it, index) in list"
              :key="index"
              class="mb-15px cursor-pointer flex items-center justify-between  hover:text-hex-$portalPrimaryColor"
              @click="jumpBusiness(it)"
            >
              <div class="flex items-center w-[calc(100%-50px)]">
                <div class="bg-$portalPrimaryColor w-6px h-6px rounded-1/2"></div>
                <p class="text-14px  truncate pl-10px w-[calc(100%-6px)]" :title="it.title">
                  {{ it.title }}
                </p>
              </div>
              <div class="w-50px text-14px text-right text-hex-999">
                {{ dayjs(it.receivedTime).format('MM/DD') }}
              </div>
            </div>
          </div>
        </div>
        <div class="text-right mt-10px" v-if="list.length">
          <el-pagination
            small
            background
            @current-change="handleCurrentChange"
            :pager-count="5"
            :current-page.sync="page.pageNum"
            :page-size.sync="page.pageSize"
            layout="total, prev, pager, next"
            :total="page.total"
          >
          </el-pagination>
        </div>
      </div>
      <div class="w-1/3 mr-10px">
        <component
          :is="listConfig[0].component"
          :data="listConfig[0]"
          mode="view"
          v-if="listConfig[0] && listConfig[0].component"
        ></component>
      </div>
      <div class="w-1/3 ">
        <component
          :is="listConfig[1].component"
          :data="listConfig[1]"
          mode="view"
          v-if="listConfig[1] && listConfig[1].component"
        ></component>
      </div>
    </div>
    <div class="w-full mt-20px ">
      <column-header class="mb-10px" title="智慧应用" @loadMore="loadMore" />
      <div class="flex relative">
        <div class="flex-1">
          <el-carousel
            ref="nop"
            :interval="5000"
            trigger="click"
            indicator-position="none"
            :arrow="appList.length <= 6 ? 'never' : ''"
            height="100px"
            :autoplay="false"
          >
            <el-carousel-item v-for="(items, i) in carouselList" :key="i">
              <div class="w-full " :class="items.length === 6 ? 'flex justify-between' : ''">
                <div
                  class="w-180px h-100px app-item inline-flex justify-center relative cursor-pointer items-center flex-col bg-hex-$portalPrimaryBgColor "
                  :class="items.length === 6 ? 'mr-0' : 'mr-20px'"
                  v-for="(item, index) in items"
                  :key="index"
                  @click="toApp(item)"
                >
                  <div class="w-40px h-40px image">
                    <img :src="`${fileUrl}${item.normalIcon}`" alt="" />
                    <img :src="`${fileUrl}${item.hoverIcon}`" alt="" />
                  </div>
                  <div class="text-14px font-normal mt-4px text-hex-000000">{{ item.name }}</div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <AddSSOConfig @save="ssoSave" :appConfig="appConfig" ref="addSSOConfig" />
  </div>
</template>

<script>
import { SingleSignOnApi, WorkbenchSettingApi, ColumnTableSearchApi } from '@wiz-api/workbench-std'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { TodoApi } from '@wiz-api/todo-management'
import { EafLoginApi } from '@wiz-api/auth-server'
import NavigationBarProps from '../components/NavigationBarProps'
import AddSSOConfig from '../components/AddSSOConfig'
import { getFieldValue, ssoLogin } from '../js/sso'

const columnHeader = () => {
  return import('../../../components/portal/ColumnHeader')
}
const NewsTwo = () => {
  return import('../../../components/portal/NewsTwo')
}
const NewsOne = () => {
  return import('../../../components/portal/NewsOne')
}
const NewsThree = () => {
  return import('../../../components/portal/NewsThree')
}
const NewsFour = () => {
  return import('../../../components/portal/NewsFour')
}
const NewsVideo = () => {
  return import('@/components/portal/NewsVideo')
}
const ImageNews = () => {
  return import('@/components/portal/ImageNews')
}
const NewsVideoTwo = () => {
  return import('@/components/portal/NewsVideoTwo')
}
const columnTableSearchApi = new ColumnTableSearchApi()
const workbenchSettingApi = new WorkbenchSettingApi()
const singleSignOnApi = new SingleSignOnApi()
const eafLoginAPi = new EafLoginApi()
const dataCategoryApi = new DataCategoryApi()
const todoApi = new TodoApi()
const roadFlowUrl = Wiz.GetModuleServer('road-flow-ele')

const { config } = Wiz.globalSettings.dynamicModules.modules['portal-homepage-std']
export default {
  components: {
    columnHeader,
    NewsTwo,
    NewsOne,
    NewsThree,
    NewsFour,
    ImageNews,
    NewsVideo,
    NewsVideoTwo,
    NavigationBarProps,
    AddSSOConfig,
  },
  data() {
    return {
      newsList: [],
      list: [],
      page: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      appList: [],
      appConfig: {},
      carouselList: [],
      listConfig: [],
      doneList: [],
      doneListNum: 0,
      todoStatus: [],
      todoSourceList: [],
    }
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
    userInfo() {
      return Wiz.AuthHooks.GetUserInfo()
    },
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  async mounted() {
    document.title = `工作台 - ${config.title}`
    await this.getDictionary()
    await this.getTodoList()
    await this.getDoneList()
    this.getWitApp()
    this.getWorkbenchSetting()
  },
  methods: {
    toHandle(status) {
      const statusCode = status === 0 ? 'todo' : 'done'
      // 有配置待办已办地址则取配置地址，否则为saas待办模块
      const configPath = `${config[`${statusCode}Route`]}`
      if (configPath) {
        config?.fromDiyCode
          ? window.open(`${Wiz.globalSettings?.globalConfig?.diyCodePage}/#${configPath}`)
          : this.$router.push(`${configPath}`)
        return
      }
      const path = `/my-business/business-management?status=${status}`
      if (config?.fromDiyCode) {
        const routerBase = `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
        window.open(`${Wiz.globalSettings?.globalConfig?.diyCodePage}/#${routerBase}${path}`)
      } else {
        this.$router.push(`${path}`)
      }
    },
    async getTodoList() {
      const [err, res] = await todoApi.todoQueryPaged({
        status: _.find(this.todoStatus, (item) => {
          return item.displayName === '待办'
        })?.id,
        userId: this.userInfo?.profile?.sub,
        skipCount: (this.page.pageNum - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
      })
      if (!err && res) {
        this.list = res.items
        this.page.total = res.totalCount
      }
    },
    async getDoneList() {
      const [err, res] = await todoApi.todoQueryPaged({
        status: _.find(this.todoStatus, (item) => {
          return item.displayName === '已办'
        })?.id,
        userId: this.userInfo?.profile?.sub,
        skipCount: (this.page.pageNum - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
      })
      if (!err && res) {
        this.doneListNum = res.totalCount
      }
    },
    async getWitApp() {
      const params = {
        name: '',
        isThirdParty: '',
        type: '',
      }
      const [err, res] = await singleSignOnApi.getAppssoSettingPage(1, 999, params)
      if (!err && res) {
        this.appList = res?.items
        this.filter(res.items)
      }
    },
    async jumpBusiness(row) {
      if (!this.todoSourceList || this.todoSourceList.length === 0) {
        this.$message({
          showClose: true,
          message: '请联系管理员配置字典',
          type: 'warning',
        })
        return
      }
      // 当点击了 source 为100的时候，单独新开一个tab，跳转工作流页面
      if (row.source === '100') {
        const opts = {
          taskId: parseInt(row.flowTaskId, 10), // Number
        }
        const [err, res] = await todoApi.getProcessInfo(opts)
        if (!err && !_.isNil(res)) {
          const url = res?.url || `${roadFlowUrl}/index.html`
          const flowid = res?.flowId || ''
          const stepid = res?.stepId || ''
          const taskid = row.flowTaskId
          const groupid = res?.groupId || ''
          const instanceid = res?.instanceId || ''
          const token = Wiz.AuthHooks.GetToken()
          const initUrl = `/flow/run/index?flowid=${flowid}&stepid=${stepid}&taskid=${taskid}&groupid=${groupid}&instanceid=${instanceid}&nroadflow-token=${token}`
          const fullUrl = `${url}?loadurl=${encodeURIComponent(initUrl)}`
          window.open(fullUrl, '_blank')
          return
        }
        this.$message({
          showClose: true,
          message: 'oa流程跳转错误',
          type: 'warning',
        })
        return
      }
      // 跳转业务页面
      const jumpUrl =
        this.todoSourceList.find((item) => {
          return item.code === row.sourceDetail
        })?.remark || ''
      if (!jumpUrl) {
        this.$message({
          showClose: true,
          message: '未找到对应的页面，请联系管理员',
          type: 'warning',
        })
        return
      }
      // 兼容检修模块消息推送
      if (
        [
          'overhaulReport',
          'overhaulPlan',
          'groupExcute',
          'overhaulDefect',
          'overhaulPackage',
          'overhaulTobeinspect',
        ].includes(row.sourceDetail)
      ) {
        const path = `${jumpUrl.replace(/\{id\}/g, row.handlePath)}`
        if (config?.fromDiyCode) {
          const routerBase = `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
          window.open(`${Wiz.globalSettings?.globalConfig?.diyCodePage}/#${routerBase}${path}`)
        } else {
          this.$router.push(`${path}`)
        }
        return
      }
      const path = `${jumpUrl}?id=${row.handlePath}&taskId=${row.flowTaskId || ''}&mode=approve`
      if (config?.fromDiyCode) {
        const routerBase = `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
        window.open(`${Wiz.globalSettings?.globalConfig?.diyCodePage}/#${routerBase}${path}`)
      } else {
        this.$router.push(`${path}`)
      }
    },
    handleCurrentChange(val) {
      this.page.pageNum = val
      this.getTodoList()
    },
    filter(val) {
      if (val && val.length > 6) {
        const row = Math.ceil(val.length / 6)
        this.carouselList = []
        for (let i = 0; i < row; i += 1) {
          this.carouselList[i] = []
          for (let j = 0; j < 6; j += 1) {
            const index = i * 6 + j
            if (index < val.length) {
              this.carouselList[i][j] = val[index]
            }
          }
        }
      } else {
        this.carouselList = []
        this.carouselList.push(val)
      }
    },
    async getWorkbenchSetting() {
      this.listConfig = []
      const [err, res] = await workbenchSettingApi.getWorkbenchSetting({ code: 'workbench' })
      if (!err && res && res.config) {
        const parseData = JSON.parse(res.config)
        _.forEach(parseData, (item) => {
          this.listConfig.push({
            ..._.pick(item, [
              'dataSource',
              'row',
              'col',
              'component',
              'imageFit',
              'title',
              'fixedHeight',
            ]),
            showContent: item.displayContent.includes('显示摘要'),
            showDate: item.displayContent.includes('显示时间'),
            showPagination: item.displayContent.includes('显示分页'),
            showTitle: item.displayContent.includes('显示栏目名称'),
            showSign: item.displayContent.includes('显示符号'),
          })
        })
      }
    },
    loadMore() {
      this.$router.push({
        path: `${this.routerBase}/integration/portal/appCenter`,
      })
    },
    async toApp(app) {
      const loginParams = app.moreParamSetting ? JSON.parse(app.moreParamSetting) : []
      let url = ''
      _.forEach(loginParams, (item) => {
        if (item.postType === 'url') {
          url += `&${item.fieldsName}=${getFieldValue(item)}`
        }
      })
      // 0:直接跳转 3：auth2.0
      if (app.loginType === 0) {
        window.open(
          `${app.loginUrl}${url ? url.replace('&', '?') : ''}`,
          '_blank',
          'noopener=yes,noreferrer=yes'
        )
      } else if (app.loginType === 3) {
        const [err, res] = await eafLoginAPi.takeOidcCode(
          'SSO_APP',
          app.loginUrl,
          'code',
          'openid profile'
        )
        if (!err) {
          if (res.isSuccess) {
            url += `&code=${res.code}`
            window.open(`${app.loginUrl}${url ? url.replace('&', '?') : ''}`)
          } else {
            this.$message.error(res.errorMessage)
          }
        }
      } else {
        const [err, res] = await singleSignOnApi.getAppssoParamsDetail({
          userId: this.userInfo?.profile?.sub,
          appId: app.id,
        })
        if (!err) {
          if (res.id !== '00000000-0000-0000-0000-000000000000') {
            ssoLogin(app, res)
          } else {
            this.appConfig = app
            this.$refs.addSSOConfig.dialogVisible = true
          }
        }
      }
    },
    ssoSave(data) {
      ssoLogin(this.appConfig, data)
      this.getWitApp()
    },
    async getDictionary() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['TodoStatus', 'TodoSource'],
        includeDetails: true,
      })
      if (!err) {
        _.forEach(res, (item) => {
          if (item.code === 'TodoStatus') {
            this.todoStatus = item.dataItems
          } else if (item.code === 'TodoSource') {
            this.todoSourceList = item.dataItems
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.clock {
  background: url('../image/clock.png') 0 0 no-repeat;
  background-size: 100%;
}
.aeroplane {
  background: url('../image/aeroplane.png') 0 0 no-repeat;
  background-size: 100%;
}
.initiate {
  background: url('../image/initiate.png') 0 0 no-repeat;
  background-size: 100%;
}
.complete {
  background: url('../image/done.png') 0 0 no-repeat;
  background-size: 100%;
}
.draft {
  background: url('../image/draft.png') 0 0 no-repeat;
  background-size: 100%;
}
.showTable {
  &::-webkit-scrollbar {
    width: 0px !important;
    display: none !important;
  }
}
.app-item {
  &:hover {
    background-color: var(--portalPrimaryColor);
    color: #fff;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      bottom: 5px;
      right: 5px;
      width: 30px;
      height: 30px;
      background: url('../image/active.png') 0 0 no-repeat;
      background-size: 100%;
    }
    .image img:last-child {
      display: block;
    }
    .image img:first-child {
      display: none;
    }
  }
  .image img:first-child {
    display: block;
  }
  .image img:last-child {
    display: none;
  }
}
</style>
